import React from 'react';

interface PromotionFullWidthCardProps {
  title: string;
  subtitle: string;
  endDate: string;
  discount: string;
  description: string;
  imageUrl: string;
  yearsExperience: number;
  numberOfEmployees: number;
  companyName: string;
  onClick: () => void;
}

const PromotionFullWidthCard: React.FC<PromotionFullWidthCardProps> = ({
  title,
  endDate,
  discount,
  description,
  imageUrl,
  yearsExperience,
  numberOfEmployees,
  companyName,
  onClick
}) => {

  return (
    <div className="w-full flex-shrink-0 overflow-hidden  ">
      <div className="flex flex-col md:flex-row h-[480px] ">
        {/* Lado izquierdo - Contenido */}
        <div className="md:w-[60%] p-8 flex flex-col ">
          {/* Título y categoría */}
          <div>
            <div className="text-xervix-text-primary dark:text-xervix-text-primary-dark font-medium mb-2 w-full">Empresa: {companyName}</div>
            <h2 className="text-5xl font-bold text-xervix-text-primary dark:text-xervix-text-primary-dark mb-2">{title}</h2>
            <div className="text-6xl font-bold text-xervix-primary mb-4">{discount} OFF</div>
            <p className="text-xervix-text-muted dark:text-xervix-text-muted-dark mb-8 w-[80%]">
              {description}
            </p>
            <button
              onClick={onClick}
              className="bg-xervix-primary hover:bg-red-500 text-white font-medium py-3 px-8 rounded-md transition-colors duration-300 mb-6"
            >
              SOLICITAR DESCUENTO
            </button>
          </div>

          {/* Estadísticas - Parte inferior */}
          <div className="flex space-x-8 mt-8">
            {/* Años de experiencia */}
            <div className="flex items-center">
              <div className="p-3 bg-orange-100 rounded-lg mr-3">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-xervix-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <div>
                <div className="text-2xl font-bold text-xervix-text-primary dark:text-xervix-text-primary-dark">{yearsExperience}</div>
                <div className="text-sm text-xervix-text-muted dark:text-xervix-text-muted-dark">Años de experiencia</div>
              </div>
            </div>

            {/* Total de servicios */}
            <div className="flex items-center">
              <div className="p-3 bg-orange-100 rounded-lg mr-3">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-xervix-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <div className="text-2xl font-bold text-xervix-text-primary dark:text-xervix-text-primary-dark">{numberOfEmployees}</div>
                <div className="text-sm text-xervix-text-muted dark:text-xervix-text-muted-dark">Total Servicios</div>
              </div>
            </div>
          </div>
        </div>

        {/* Lado derecho - Imagen */}
        <div className="md:w-[40%] relative">
          {/* Imagen */}
          <div className="h-full w-full rounded-xl">
            <img
              src={imageUrl}
              alt={title}
              className="h-full w-full object-cover rounded-xl"
            />
          </div>

          {/* Tarjeta de información de la empresa superpuesta */}
          <div className="absolute bottom-8 right-8 bg-white dark:bg-gray-800 p-4 rounded-lg shadow-md max-w-xs">
            <div className="flex items-center">

              <div>
                <h3 className="font-bold text-gray-800 dark:text-white">{companyName}</h3>
                <div className="flex items-center">
                  <p className="text-sm text-gray-600 dark:text-gray-300 mr-2">Fin promoción {endDate.split('T')[0]}</p>

                </div>
                <div className="flex text-yellow-400 mt-1">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>

              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  );
};

export default PromotionFullWidthCard;
